Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.WordsCloudView extends Backbone.View
  include @, Monitoring.Reports.Campaign.Utils

  className: 'words-cloud'
  template: JST['backbone/templates/monitoring/reports/campaign/words_cloud']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template())
    @$el.addClass('processing')


    params = @paramsForChildsOfPosts
      ngrams_limit: 20
      exclude_page_owner_generated: true

    job = new Monitoring.Methods.AsyncJob()
    job.bind('completed', @_renderCloud)
    job.start('words', params)

    canvas = @$el.find('canvas')
    canvas.on('wordcloudstop', @addDownloadButton)

  _renderCloud: (data) =>
    @$el.removeClass('processing')

    renderer = new Monitoring.Methods.RenderWordCloud(data.topic_ranking)
    list = renderer.renderInElement(@el.querySelector('canvas'))

    @trigger(@options.section + 'SectionRendered', {wordList: list})
    @trigger('rendered')

  addDownloadButton: =>
    canvas = @$el.find('canvas')[0]
    downloadForm = $('<a id="download" download="word-cloud.png" target="_blank"><i class="fa fa-download cloud-download"></i></a>')
    downloadForm.attr('href', canvas.toDataURL())
    @$el.find(".cloud-download").hide()
    @$el.closest(".chart-container").find(".chart-title").prepend(downloadForm)
    @$el.closest(".chart-container").find(".cloud-download").hide()
    @$el.closest(".chart-container").hover (->
      $(this).find(".cloud-download").show()
      return
    ), ->
      $(this).find(".cloud-download").hide()
      return
